import { Box, Button, Stack, Typography } from "@mui/material";
import { GridFooterContainer, GridPagination } from "@mui/x-data-grid";
import LocalShipping from "@mui/icons-material/LocalShipping";
import Edit from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";

interface TableFooterProps {
  selectedCount: number;
  onBatchEdit: () => void;
  onBatchDelete: () => void;
  onCreateShipment?: () => void;
  canCreateShipment?: boolean;
  canDelete?: boolean;
}

export default function FooterTable({
  selectedCount,
  onBatchEdit,
  onBatchDelete,
  onCreateShipment,
  canCreateShipment = true,
  canDelete = true,
}: TableFooterProps) {
  return (
    <GridFooterContainer
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderTop: "1px solid #e0e0e0",
      }}
    >
      {selectedCount > 0 ? (
        <Box
          sx={{
            flex: 1,
            px: 2,
            py: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Typography variant="body2" sx={{ my: 0 }}>
            {selectedCount} elemento(s) seleccionado(s)
          </Typography>
          <Stack direction="row" spacing={1}>
            {onCreateShipment && (
              <Button 
                variant="contained" 
                size="small" 
                onClick={onCreateShipment}
                startIcon={<LocalShipping />}
                disabled={!canCreateShipment}
                title={!canCreateShipment ? "Algunos paquetes seleccionados ya tienen un envío asignado" : ""}
              >
                Crear envío
              </Button>
            )}
            <Button 
              variant="outlined" 
              size="small" 
              onClick={onBatchEdit}
              startIcon={<Edit />}
            >
              Editar seleccionados
            </Button>
            {canDelete && (
              <Button 
                variant="outlined" 
                color="error" 
                size="small" 
                onClick={onBatchDelete}
                startIcon={<Delete />}
              >
                Eliminar seleccionados
              </Button>
            )}
          </Stack>
        </Box>
      ) : (
        <Box sx={{ flex: 1 }} />
      )}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          minWidth: "fit-content",
        }}
      >
        <GridPagination />
      </Box>
    </GridFooterContainer>
  );
}
